module.exports = __webpack_public_path__ + "static/img/03.91d501ea.jpg";